"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function KanalTedavisiHakkinda() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="kanal-tedavisi-hakkında" className="bg-background py-20 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          
          {}
          <div ref={textRef} className={`lg:col-span-6 flex flex-col justify-center transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h1 className="font-serif text-5xl md:text-6xl lg:text-[84px] font-light text-foreground leading-[1.1] tracking-tight">
              Kanal Tedavisi
            </h1>
            
            <Separator className="w-[60px] h-[1px] bg-primary my-8 lg:my-12" decorative />
            
            <div className="space-y-6 font-sans text-base lg:text-[16px] leading-[1.6] tracking-wide text-muted-foreground">
              <p>
                Kanal tedavisi, hasar görmüş veya enfekte olmuş bir dişin kurtarılması ve onarılması için uygulanan, dişin özünü (pulpa) hedef alan hassas bir prosedürdür. Modern diş hekimliğinde, gelişmiş anestezi teknikleri ve mikro aletler sayesinde bu işlem, rutin bir dolgu kadar konforlu ve ağrısız bir şekilde gerçekleştirilmektedir.
              </p>
              <p>Kliniğimizde, en son teknoloji ürünü görüntüleme sistemleri ve döner aletler kullanılarak kanal tedavileriniz yüksek hassasiyetle tamamlanır. Amacımız, doğal dişinizi ağızda tutarak hem estetik hem de fonksiyonel bütünlüğünüzü uzun yıllar boyunca korumaktır.</p>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`lg:col-span-6 relative h-[400px] sm:h-[500px] lg:h-[700px] w-full rounded-[2px] overflow-hidden shadow-[0_10px_40px_-10px_rgba(0,0,0,0.08)] transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            {}
            <img src="https://dtaysegul.10web.cloud/wp-content/uploads/2026/04/IMG_2429.JPG-scaled.jpeg" alt="Modern ve Lüks Diş Kliniği Odası" className={`absolute inset-0 w-full h-full object-cover transition-transform duration-[2000ms] ease-out ${isImageVisible ? "scale-100" : "scale-105"}`} />
            {}
            <div className="absolute inset-0 bg-white/5 pointer-events-none mix-blend-overlay"></div>
          </div>

        </div>
      </div>
    </section>;
}